export default __webpack_public_path__ + "static/media/headerLogo.3da25949.png";